module.exports = __webpack_public_path__ + "static/media/favorito.f87efdd5.svg";